"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Environment = void 0;
var Environment;
(function (Environment) {
    Environment["Development"] = "development";
    Environment["Local"] = "local";
    Environment["Production"] = "production";
})(Environment = exports.Environment || (exports.Environment = {}));
